import React from "react";
import InstructorImage from "../../assets/images/edit-profile-thumbnail.svg";
const CourseDetailsInstructorInfo = ({ instructorInfo }) => {
  return (
    <>
      <h2 className="ah-heading-04 fw-bold mb-20">Instructor</h2>
      <div className="instructor-card d-flex flex-column flex-md-row align-items-center gap-2 gap-md-4">
        <div className="instructor-image-wrapper p-5 flex-shrink-0">
          <img
            src={
              process.env.REACT_APP_GALLERY_URL +
                instructorInfo?.profile_picture || InstructorImage
            }
            alt={instructorInfo?.full_name}
            className="instructor-image img-fluid"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = InstructorImage;
            }}
          />
        </div>
        <div>
          <h4 className="ah-heading-04 fw-bold text-black-100">
            {instructorInfo?.full_name}
          </h4>
          <h6 className="ah-text-xl fw-bold mb-3 text-black-100-80">
            {instructorInfo?.role || "Instructor"}
          </h6>
          <p className="text-black-100-80 ah-text-xl mb-0">
            {instructorInfo?.bio || "Not Provided"}
          </p>
        </div>
      </div>
    </>
  );
};

export default CourseDetailsInstructorInfo;
